import React from 'react';
import FormGroup from './FormGroup';

const FormRow = (props) => (
    <div className="row">
        <FormGroup {...props} />
    </div>
);

export default FormRow;
